import actionLog from './action'
import exceptionLog from './exception'
import loginLog from './login/index.vue'
import rights from './rights'
import role from './role'
import sysCode from './sysCode'
import user from './user'
import home from './home.vue'
import login from './login.vue'

export default {
    actionLog,
    exceptionLog,
    loginLog,
    rights,
    role,
    sysCode,
    user,
    home,
    login
}